/**
 * Represents the zeus.apollon_fk_conf entity - the Foerderkategorie config
 * structure
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import { Config } from './apollon_conf_fk/Config';
import dayjs, { Dayjs } from 'dayjs';
import { createModel, type MutationsObject } from '@kp/js-model';
import { LookupCollection } from './BaseCollection';
import { Kontakte } from './apollon_conf_fk/Kontakte';

export class ApollonConfFk extends BaseModel {
    id: number | null = null;
    kanton_id: number | null = null;
    foerderkategorie_id: number | null = null;
    fk_gruppe_id: number | null = null;
    reihenfolge: number | null = null;
    bezeichnung_apollon: string | null = null;
    einreichung_ab: Dayjs | null = null;
    einreichung_bis: Dayjs | null = null;
    abschluss_ab: Dayjs | null = null;
    abschluss_bis: Dayjs | null = null;
    hilfetext: string | null = null;
    foerderbedingungen_html: string | null = null;
    kontakte: Kontakte | null = null;
    config: Config | null = null;

    kanton_kuerzel: string | null = null;
    foerderkategorie: string | null = null;
    foerderkategorie_aktiv: boolean | null = null;
    foerderkategorie_gruppe: string | null = null;
    foerderkategorie_gruppe_hilfetext: string | null = null;
    gesuchsvorlage_id: number | null = null;

    public mutations(): MutationsObject {
        return {
            id: (id: number) => (Number(id) > 0 ? Number(id) : null),
            einreichung_ab: (val: Dayjs) => (val ? dayjs(val) : null),
            einreichung_bis: (val: Dayjs) => (val ? dayjs(val) : null),
            abschluss_ab: (val: Dayjs) => (val ? dayjs(val) : null),
            abschluss_bis: (val: Dayjs) => (val ? dayjs(val) : null),
            config: (val: Config) => createModel(Config, val),
            kontakte: (val: Kontakte) => createModel(Kontakte, val)
        };
    }

    getClassName(): string {
        return 'apollonConfFk';
    }
}
export class ApollonConfFkCollection extends LookupCollection<ApollonConfFk> {
    protected modelCls = ApollonConfFk;
    getModelClassName(): string {
        return 'apollonConfFk'
    }
}
